export const camerasSettingsColumns = [
  {
    label: 'Name',
    value: 'name',
    mobile: true,
  },
  {
    label: 'Codec',
    value: 'codec',
  },
  {
    label: 'Bitrate',
    value: 'bitrate',
  },
  {
    label: 'FPS',
    value: 'fps',
  },
  {
    label: 'Resolution',
    value: 'resolution',
  },
  { label: '', value: 'menu', mobile: true },
];

export const camerasSortOptions = [
  {
    label: 'Name',
    value: 'name',
  },
];
